/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * API to get important events relevant for logged-in user
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequiredActionsResponse
 */
export interface RequiredActionsResponse {
    /**
     * Number of actions to perform
     * @type {number}
     * @memberof RequiredActionsResponse
     */
    shiftsPlanned?: number;
    /**
     * Number of actions to perform
     * @type {number}
     * @memberof RequiredActionsResponse
     */
    applicantsToApprove?: number;
    /**
     * Number of actions to perform
     * @type {number}
     * @memberof RequiredActionsResponse
     */
    registrationsToApprove?: number;
}

export function RequiredActionsResponseFromJSON(json: any): RequiredActionsResponse {
    return RequiredActionsResponseFromJSONTyped(json, false);
}

export function RequiredActionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequiredActionsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'shiftsPlanned': !exists(json, 'shiftsPlanned') ? undefined : json['shiftsPlanned'],
        'applicantsToApprove': !exists(json, 'applicantsToApprove') ? undefined : json['applicantsToApprove'],
        'registrationsToApprove': !exists(json, 'registrationsToApprove') ? undefined : json['registrationsToApprove'],
    };
}

export function RequiredActionsResponseToJSON(value?: RequiredActionsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'shiftsPlanned': value.shiftsPlanned,
        'applicantsToApprove': value.applicantsToApprove,
        'registrationsToApprove': value.registrationsToApprove,
    };
}

